import {Component,Inject, Input} from 'ng-metadata/core';


@Component({
selector: 'prm-login-item',
templateUrl: 'components/security/login/loginItem/login-item.html',
})



export class PrmLoginItem{
    @Input() private authenticationMethod; AuthenticationMethod;

    constructor(@Inject('loginIcons') private loginIcons) {
    }

    public getProfileLinkForDisplay( index ) {
        let linkNumber = index + 1;
        return "parallel.login.link" + linkNumber;
    }

    public getProfileLinkDescriptionForDisplay( index ) {
        let linkNumber = index + 1;
        return "parallel.login.description" + linkNumber;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/security/login/loginItem/loginItem.directive.ts